import { render } from "./count-to.vue?vue&type=template&id=71c85496&scoped=true"
import script from "./count-to.vue?vue&type=script&lang=js"
export * from "./count-to.vue?vue&type=script&lang=js"

import "./count-to.vue?vue&type=style&index=0&id=71c85496&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71c85496"

export default script